import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Row } from '../grid/experimental.grid';

export interface FocusSelectorSelectClosedForTeamRow {
    rowId: Row['id'];
}

export const focusSelectorSelectClosedForTeamRow = createAction<
    ActionType,
    FocusSelectorSelectClosedForTeamRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_CLOSED_FOR_TEAM_ROW);
